export default function formatText(text) {
    if (text) {
        let texts = text.split(/\n/g);
        let result = _.map(texts, function(t) {
            return `<p>${t}</p>`;
        }).join('');
        return result;
    }
    return '';
}
